// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"148":"82634966","198":"da9c1244","528":"fdcec50d","747":"9b4a18f4","787":"5ad96c4b","829":"8ac2a556"}[chunkId] + ".chunk.js";
};